import { Box, BoxProps, forwardRef } from '@chakra-ui/react';

import { createUseVariantStyle } from '@bonusly/ds-hooks';

export type TextSize = 'sm' | 'md' | 'lg' | 'xl';
export type TextVariant = 'normal' | 'strong' | 'medium';

export interface TextProps extends BoxProps {
	size?: TextSize;
	variant?: TextVariant;
}

const useVariantStyle = createUseVariantStyle({
	size: {
		sm: {
			fontSize: 50,
		},
		md: {
			fontSize: 100,
		},
		lg: {
			fontSize: 150,
		},
		xl: {
			fontSize: 200,
		},
	},
	variant: {
		normal: {
			fontWeight: 'normal',
		},
		medium: {
			fontWeight: 'medium',
		},
		strong: {
			fontWeight: 'semibold',
		},
	},
});

const Text = forwardRef(({ size = 'md', variant = 'normal', ...rest }: TextProps, ref) => {
	const styles = useVariantStyle({ size, variant });

	return <Box as="p" fontFamily="ui" letterSpacing="ui" lineHeight="base" ref={ref} {...styles} {...rest} />;
});

Text.displayName = 'Text';

export { Text };
